import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-4 h-full flex flex-col gap-2"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "loadingEl h-4 rounded-md bg-gray-50",
  style: { width: '40%' }
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "loadingEl flex-1 rounded-md bg-gray-50" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import { ArrowsPointingOutIcon, EllipsisVerticalIcon, XMarkIcon } from "@heroicons/vue/24/outline";
import { differenceInSeconds } from "date-fns";
import { ref, watch } from "vue";
import Modal from "shared/components/modals/Modal.vue";
import DashboardDragHandle from "@/views/dashboard/componentsV2/DashboardDragHandle.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseWidget',
  props: {
    isLoading: { type: Boolean },
    showContentOnLoading: { type: Boolean },
    hideDragHandle: { type: Boolean },
    menuClass: {},
    showZoomIcon: { type: Boolean },
    useWhiteIcons: { type: Boolean }
  },
  emits: ["delete", "trackInteraction", "trackZoomClicked"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

const openZoomModal = ref(false);

const zoomContainer = ref<HTMLDivElement | null>(null);
const zoomedViewHeight = ref<number>(0);

watch(zoomContainer, () => {
  if (zoomContainer.value) {
    zoomedViewHeight.value = zoomContainer.value.getBoundingClientRect().height;
  }
});

const totalDistance = ref(0);
const lastSeenAt = ref({ x: 0, y: 0 });
const clickCount = ref(0);
const startTime = ref();

const handleMouseEnter = () => {
  totalDistance.value = 0;
  lastSeenAt.value = { x: 0, y: 0 };
  clickCount.value = 0;
  startTime.value = new Date();
};

const handleClick = () => {
  clickCount.value += 1;
};

const handleMouseMove = (event: MouseEvent) => {
  if (lastSeenAt.value.x && lastSeenAt.value.y) {
    totalDistance.value += Math.sqrt(
      Math.pow(lastSeenAt.value.y - event.clientY, 2) +
        Math.pow(lastSeenAt.value.x - event.clientX, 2),
    );
  }
  lastSeenAt.value.x = event.clientX;
  lastSeenAt.value.y = event.clientY;
};

const handleMouseLeave = () => {
  const endTime = new Date();
  const diff = differenceInSeconds(endTime, startTime.value);
  const result = clickCount.value * 200 + Math.round(diff) * 20 + Math.round(totalDistance.value);
  if (result > 1000) {
    emit("trackInteraction");
  }
  totalDistance.value = 0;
  lastSeenAt.value = { x: 0, y: 0 };
  clickCount.value = 0;
  startTime.value = "";
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bg-white shadow rounded-md h-full", [
      _ctx.useWhiteIcons ? 'oaiBaseWidgetUseWhiteIcons' : '',
      _ctx.isLoading && _ctx.showContentOnLoading ? 'overflow-hidden' : 'overflow-auto',
    ]]),
    onMouseenter: handleMouseEnter,
    onMousemove: handleMouseMove,
    onMouseleave: handleMouseLeave,
    onClick: handleClick
  }, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
      : _createCommentVNode("", true),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["absolute top-3 right-2 z-50 vgl-item__menu items-center", _ctx.menuClass])
        }, [
          (_ctx.showZoomIcon)
            ? (_openBlock(), _createBlock(_unref(ArrowsPointingOutIcon), {
                key: 0,
                class: _normalizeClass(["w-4 h-4 z-[9999] cursor-pointer", { 'text-white': _ctx.useWhiteIcons }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => {
          openZoomModal.value = true;
          emit('trackZoomClicked');
        })
              }, null, 8, ["class"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(Menu), {
            as: "div",
            class: "relative"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(MenuButton), { class: "flex items-center text-gray-600" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(EllipsisVerticalIcon), {
                    class: _normalizeClass(["w-6 h-6", { 'text-white': _ctx.useWhiteIcons }])
                  }, null, 8, ["class"])
                ]),
                _: 1
              }),
              _createVNode(_unref(MenuItems), {
                class: "absolute -right-3 z-50 mt-2 origin-top-right rounded-md overflow-hidden bg-white shadow focus:outline-none",
                style: { width: '200px' }
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "menuItems"),
                  _createVNode(_unref(MenuItem), {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('delete')))
                  }, {
                    default: _withCtx(({ active }) => [
                      _createElementVNode("div", {
                        class: _normalizeClass([
                active ? 'bg-gray-100 text-yellow-600' : 'text-gray-700',
                'px-4 py-2 text-sm cursor-pointer truncate flex items-center gap-2',
              ])
                      }, [
                        _createVNode(_unref(XMarkIcon), { class: "w-5 h-5" }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("dashboard.remove_widget")), 1)
                      ], 2)
                    ]),
                    _: 1
                  })
                ]),
                _: 3
              })
            ]),
            _: 3
          })
        ], 2))
      : _createCommentVNode("", true),
    (!_ctx.hideDragHandle && !_ctx.isLoading)
      ? (_openBlock(), _createBlock(DashboardDragHandle, {
          key: 2,
          class: "absolute left-4 z-50 top-[17px]",
          iconClass: _ctx.useWhiteIcons ? 'fill-white' : ''
        }, null, 8, ["iconClass"]))
      : _createCommentVNode("", true),
    (!_ctx.isLoading || _ctx.showContentOnLoading)
      ? _renderSlot(_ctx.$slots, "default", { key: 3 })
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "modals"),
    _createVNode(Modal, {
      open: openZoomModal.value,
      onClose: _cache[2] || (_cache[2] = ($event: any) => {
        openZoomModal.value = false;
        zoomContainer.value = null;
        zoomedViewHeight.value = 0;
      }),
      "custom-cls": "w-full mx-auto overflow-hidden h-full"
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", {
          class: "h-full overflow-auto",
          ref_key: "zoomContainer",
          ref: zoomContainer
        }, [
          (zoomedViewHeight.value > 0)
            ? _renderSlot(_ctx.$slots, "zoomedView", {
                key: 0,
                height: zoomedViewHeight.value
              })
            : _createCommentVNode("", true)
        ], 512)
      ]),
      _: 3
    }, 8, ["open"])
  ], 34))
}
}

})